import dayjs from "dayjs";

export function getRelativeTime(inputDate: string | Date): string {
    return dayjs(inputDate).fromNow();
}